import type { Translation } from "./types";

const en: Translation = {
  home: {
    title: "AI my bro",
    subtitle: "It's time to build!",
  },
  about: {
    link: "About",
    title: "About",
    subtitle: "Our team and promise behind AI my bro",
  },
  navigation: {
    en: "English",
    kr: "Korean",
    es: "Spanish",
    zh: "Chinese",
  },
  menu: {
    explain: "Explain",
    chat: "Chat",
    quiz: "Quiz",
    progress: "Progress",
  },
  auth: {
    login: {
      title: "Sign into your account",
      subtitle: "Please enter your details",
      email: "Email",
      password: "Password",
      forgotPassword: "Forgot your password?",
      loginButton: "Log in",
      emailNotConfirmed: "Email not confirmed",
      resendConfirmation: "Resend confirmation email",
      noAccount: "Don't have an account?",
      signUp: "Sign up",
      emailPlaceholder: "example@email.com",
      passwordPlaceholder: "Enter your password",
    },
    join: {
      title: "Create an account",
      subtitle: "Please enter your details to create an account",
      name: "Name",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      marketingConsent: "Sign up for marketing emails",
      termsAgreement:
        "I have read and agree to the Terms of Service and Privacy Policy",
      termsOfService: "Terms of Service",
      privacyPolicy: "Privacy Policy",
      createAccount: "Create account",
      accountCreated: "Account created!",
      emailVerificationRequired:
        "Email verification required. Please check your email.",
      alreadyHaveAccount: "Already have an account?",
      signIn: "Sign in",
      namePlaceholder: "John Doe",
      emailPlaceholder: "example@email.com",
      passwordHint: "Must be at least 8 characters long.",
      passwordPlaceholder: "Enter your password",
      confirmPasswordPlaceholder: "Enter your password again",
      and: "and",
      agreeTo: ".",
    },
    forgotPassword: {
      title: "Forgot your password?",
      subtitle: "Enter your email and we'll send you a reset link.",
      email: "Email",
      emailPlaceholder: "nico@supaplate.com",
      sendButton: "Send reset link",
      successMessage:
        "Check your email for a reset link, you can close this tab.",
    },
    newPassword: {
      title: "Update your password",
      subtitle: "Enter your new password and confirm it.",
      password: "Password",
      confirmPassword: "Confirm password",
      passwordPlaceholder: "Enter your new password",
      confirmPasswordPlaceholder: "Confirm your new password",
      updateButton: "Update password",
      successMessage: "Password updated successfully!",
      passwordsMatchError: "Passwords must match",
      redirectMessage: "Redirecting to login page in {{seconds}} seconds...",
      goToLogin: "Go to Login",
    },
  },
  landing: {
    hero: {
      quote:
        "Study what you are most interested in in the most undisciplined, irreverent and original manner possible",
      author: "Richard Feynman",
    },
    intro: {
      title: "Self-directed Learning with AI my bro",
      subtitle:
        "The more you explain, the smarter you get. AI bro gives you cute and sharp feedback.",
      features: {
        organize: "Organize Ideas",
        practice: "Practice Explaining",
        learning: "Deep Learning",
      },
      cta: "Start Teaching AI Bro",
    },
    examples: {
      title: "Here's How People Explained Things!",
      physics: {
        user: "Gravity is the force that makes things fall down",
        ai: "Right! The apple fell to the ground too 🍎 But why doesn't the moon fall down?",
      },
      biology: {
        user: "Photosynthesis is how plants make food using light",
        ai: "Wow! 🌱 So plants are like chefs! What ingredients do they need?",
      },
      politics: {
        user: "Democracy is when people govern the country",
        ai: "Cool! 🗳️ So can anyone become president?",
      },
    },
    footer: {
      description:
        "AI my bro is your reliable learning partner that helps you develop the power to organize knowledge through words.",
    },
  },
  contact: {
    title: "Contact Us",
    subtitle:
      "Have any questions? Feel free to reach out to us. We'll get back to you quickly.",
    form: {
      name: "Name",
      email: "Email",
      message: "Message",
      namePlaceholder: "Enter your name",
      emailPlaceholder: "Enter your email",
      messagePlaceholder: "Enter your message",
      sendButton: "Send",
      captchaNote:
        "Using Cloudflare Turnstile for enhanced security and user experience.",
    },
    messages: {
      success: "Message sent successfully",
      error: "An error occurred while sending your message",
      captchaError: "Security verification failed. Please try again.",
    },
  },
  legal: {
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    youthPolicy: "Youth Protection Policy",
    cookiePolicy: "Cookie Policy",
  },
  settings: {
    profile: {
      title: "Profile editing function (temporarily disabled)",
      subtitle: "You can view your profile information.",
      name: "Name",
    },
    name: {
      title: "Change name",
      subtitle: "Change your display name.",
      currentName: "Current name",
      newName: "New name",
      namePlaceholder: "Enter new name",
      changeButton: "Change name",
      successMessage: "Name changed successfully",
    },
    email: {
      title: "Change email",
      titleAdd: "Add email",
      subtitle: "Change your email address.",
      subtitleAdd: "Add an email address to your account.",
      currentEmail: "Current email",
      newEmail: "New email",
      changeButton: "Change email",
      addButton: "Add email",
      successMessage:
        "Email update process started. Please check your old email for a verification link.",
    },
    password: {
      title: "Change password",
      titleAdd: "Add password",
      subtitle: "Change your password.",
      subtitleAdd: "Add a password to your account.",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      changeButton: "Change password",
      addButton: "Add password",
      successMessage: "Password updated",
    },
    social: {
      title: "Connect social accounts",
      subtitle:
        "Add or remove additional authentication methods to your account.",
    },
    danger: {
      title: "Danger Zone",
      confirmDelete: "I confirm that I want to delete my account.",
      confirmIrreversible: "I understand that this action is irreversible.",
      deleteButton: "Delete account",
    },
  },
  error: {
    title: "Error",
    errorCode: "Error code",
    goHome: "Go to home",
    otpExpired: "Email link is invalid or has expired",
    invalidLink:
      "The email link has expired or has already been used. Please request a password reset again.",
  },
  common: {
    beta: "BETA",
    betaNotice:
      "This service is in beta. Please send us feedback if you encounter any issues.",
  },
};

export default en;
